import { AbstractControl } from '@angular/forms';

export function setControlDisabled(control?: AbstractControl, disabled: boolean | null = true): void {
  const action = disabled ? 'disable' : 'enable';
  control?.[action]({ emitEvent: false });
}
